import { GeoLocationPingStatus } from '@core/services/location/types';
import { getShellConfig } from '@src/config/shell/config';

export class PingRetryController {
    private isRetryEnabled: boolean;
    private previous: GeoLocationPingStatus | null = null;
    private current: GeoLocationPingStatus | null = null;

    constructor(isRetryEnabled: boolean) {
        this.isRetryEnabled = isRetryEnabled;
    }

    registerPing(pingStatus: GeoLocationPingStatus) {
        this.previous = this.current;
        this.current = pingStatus;
    }

    /**
     * Retries only if this is first ping ever and GeoLocs rejections or it this is the first GeoLocs rejection after 1
     * success
     */
    mustRetry(): boolean {
        const isFirstPing = !this.previous;
        const isPreviousSuccess = this.previous === GeoLocationPingStatus.Ok;
        return this.isRetryEnabled
            && this.current === GeoLocationPingStatus.Blocked && (isFirstPing || isPreviousSuccess);
    }
}

export const pingRetryController = new PingRetryController(getShellConfig().remoteConfig.isGeoLocsRetryOnFirstRejectEnabled);
